import React, { useState } from "react";
import { Button, Grid, Paper, TextField, Typography } from "@material-ui/core";
import logo from "images/logoAbbott.png";

const INITIAL_FORM = {
  rut: "",
  phone: "",
  requesterName: "",
  newEmail: "",
  repeatedNewEmail: "",
};

function ModifyEmailForm() {
  const [form, setForm] = useState(INITIAL_FORM);

  const handleFormChange = (event) => {
    setForm((currentForm) => ({
      ...currentForm,
      [event.target.name]: event.target.value,
    }));
  };

  const isFormComplete = Object.values(form).every((value) => value.trim());

  return (
    <Grid
      container
      style={{
        minHeight: "100vh",
        flexDirection: "column",
        flexWrap: "nowrap",
        backgroundColor: "#F6F7FF",
      }}
    >
      <header
        style={{
          width: "100%",
          height: "96px",
          minHeight: "96px",
          display: "flex",
          alignItems: "center",
          padding: "8px 32px",
          backgroundColor: "#c3c3e3",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          boxSizing: "border-box",
        }}
      >
        <img
          src={logo}
          alt="Abbott"
          style={{ height: "80px", width: "auto", objectFit: "contain" }}
        />
      </header>

      <Grid
        item
        xs={12}
        style={{
          width: "100%",
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "32px 16px",
          boxSizing: "border-box",
        }}
      >
        <Paper
          elevation={3}
          style={{
            width: "100%",
            maxWidth: "596px",
            padding: "40px 32px",
            textAlign: "center",
            borderRadius: "8px",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h4"
            style={{ fontSize: "34px", fontWeight: 400, marginBottom: "20px" }}
          >
            Cambio de correo
          </Typography>
          <Typography
            style={{ fontSize: "20px", lineHeight: 1.6, marginBottom: "32px" }}
          >
            Complete sus datos para solicitar el cambio de correo.
          </Typography>
          <TextField
            fullWidth
            label="Usuario"
            value="eco3"
            InputProps={{ readOnly: true }}
            variant="outlined"
            style={{ marginBottom: "20px" }}
          />
          <TextField
            required
            fullWidth
            label="RUT"
            name="rut"
            onChange={handleFormChange}
            value={form.rut}
            variant="outlined"
            style={{ marginBottom: "20px" }}
          />
          <TextField
            required
            fullWidth
            label="Teléfono"
            name="phone"
            onChange={handleFormChange}
            type="tel"
            value={form.phone}
            variant="outlined"
            style={{ marginBottom: "20px" }}
          />
          <TextField
            required
            fullWidth
            label="Nombre del solicitante"
            name="requesterName"
            onChange={handleFormChange}
            value={form.requesterName}
            variant="outlined"
            style={{ marginBottom: "20px" }}
          />
          <TextField
            fullWidth
            label="Correo actual"
            type="email"
            variant="outlined"
            style={{ marginBottom: "20px" }}
          />
          <TextField
            required
            fullWidth
            label="Correo nuevo"
            name="newEmail"
            onChange={handleFormChange}
            type="email"
            value={form.newEmail}
            variant="outlined"
            style={{ marginBottom: "20px" }}
          />
          <TextField
            required
            fullWidth
            label="Repita correo nuevo"
            name="repeatedNewEmail"
            onChange={handleFormChange}
            type="email"
            value={form.repeatedNewEmail}
            variant="outlined"
            style={{ marginBottom: "20px" }}
          />
          <TextField
            fullWidth
            label="Comentarios"
            multiline
            minRows={4}
            variant="outlined"
            style={{ marginBottom: "32px" }}
          />
          <Button
            variant="contained"
            color="primary"
            size="large"
            disabled={!isFormComplete}
          >
            Enviar solicitud
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default ModifyEmailForm;
